import { render, staticRenderFns } from "./SArticlesGroup.vue?vue&type=template&id=a2d1f790"
import script from "./SArticlesGroup.vue?vue&type=script&lang=js"
export * from "./SArticlesGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports